import { useState, useRef, useEffect } from "react";
import ChevronUpIcon from "@/icons/ChevronUpIcon";
import ChevronDownIcon from "@/icons/ChevronDownIcon";
import MarkdownText from "@/components/ui/MarkdownText";
import styles from "./expandable-text.module.css";

export default function ExpandableText({ value, line = 3, markdown = false }) {
  const [expanded, setExpanded] = useState(false);
  const [needsExpand, setNeedsExpand] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (!textRef.current || typeof value !== "string") {
      setNeedsExpand(false);
      return;
    }

    const checkIfNeedsExpand = () => {
      const element = textRef.current;
      if (!element) return;

      // Проверяем только в свернутом состоянии
      if (!expanded) {
        const isTextClamped = element.scrollHeight > element.clientHeight;
        setNeedsExpand(isTextClamped);
      }
    };

    // Проверяем сразу
    checkIfNeedsExpand();

    // Отслеживаем изменение размеров элемента
    const resizeObserver = new ResizeObserver(checkIfNeedsExpand);
    resizeObserver.observe(textRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [value, line, expanded]);

  if (typeof value !== "string") {
    return value ?? "";
  }

  return (
    <div className={styles.container}>
      <div
        ref={textRef}
        className={styles.item}
        style={
          expanded
            ? { whiteSpace: "pre-wrap" }
            : {
                display: "-webkit-box",
                WebkitLineClamp: line,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "pre-wrap",
              }
        }
      >
        {markdown ? <MarkdownText value={value} /> : value}
      </div>

      {needsExpand && (
        <div
          className={
            expanded ? styles.toggle_button_collapse : styles.toggle_button
          }
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((v) => !v);
          }}
        >
          {expanded ? (
            <>
              <ChevronUpIcon style={{ fontSize: 14 }} />
              <span>свернуть</span>
            </>
          ) : (
            <>
              <ChevronDownIcon style={{ fontSize: 14 }} />
              <span>показать все</span>
            </>
          )}
        </div>
      )}
    </div>
  );
}
